import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const careData = [
    {
        title: "Patient Rights & Responsibilities",
        desc: "Respectful care, privacy, informed consent, and clear communication regarding treatment.",
    },
    {
        title: "Room Availability",
        desc: "General Ward, Deluxe Rooms, and ICU facilities based on medical needs.",
    },
    {
        title: "Admission & Discharge Process",
        desc: "Smooth admission and guided discharge with billing and follow-up support.",
    },
    {
        title: "Insurance & Cashless Facilities",
        desc: "Cashless treatment support through multiple insurance and TPA tie-ups.",
    },
    {
        title: "Visitor Policies & Visiting Hours",
        desc: "Controlled visiting hours for patient safety and recovery.",
    },
    {
        title: "Patient Support Team",
        desc: "Dedicated support team for guidance, assistance, and grievance resolution.",
    },
];

function PatientCare() {
    return (
        <section className="py-10">
            <div className="max-w-7xl mx-auto px-4">

                {/* 🔵 MAIN GRADIENT BOX */}
                <div
                    className="rounded-3xl shadow-2xl p-12"
                    style={{
                        background:
                            "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3, #fde7f3)",
                    }}
                >
                    {/* Heading */}
                    <h2 className="text-4xl font-bold text-center text-white mb-14">
                        Patient Care Information
                    </h2>

                    {/* ===== CENTERED SLIDER ===== */}
                    <Swiper
                        modules={[Navigation, Pagination, Autoplay]}
                        navigation
                        pagination={{ clickable: true }}
                        loop
                        autoplay={{ delay: 3500 }}
                        spaceBetween={20}
                        centeredSlides={false}
                        slidesPerView={1}
                        breakpoints={{
                            768: {
                                slidesPerView: 1.5,
                                centeredSlides: true,
                                spaceBetween: 30,
                            },
                        }}
                        className="patientCareSlider max-w-6xl mx-auto"
                    >

                        {careData.map((item, i) => (
                            <SwiperSlide key={i}>
                                <div className="careCard">
                                    <h3>{item.title}</h3>
                                    <p>{item.desc}</p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    {/* ===== CUSTOM STYLES ===== */}
                    <style>{`
                        .patientCareSlider .swiper-slide {
                            transition: transform 0.4s ease, opacity 0.4s ease;
                            opacity: 0.4;
                            transform: scale(0.85);
                        }

                        .patientCareSlider .swiper-slide-active {
                            opacity: 1;
                            transform: scale(1);
                        }
.careCard {
    background: rgba(255, 255, 255, 0.92); /* ✅ light card */
    color: #0b1d3a;                        /* dark readable text */
    min-height: 210px;
    padding: 26px;
    border-radius: 22px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;

    box-shadow: 0 14px 30px rgba(0, 0, 0, 0.25);
}

.careCard h3 {
    font-size: 26px;        /* 🔥 bigger heading */
    font-weight: 700;
    margin-bottom: 14px;
    color: #0b3c78;
}

.careCard p {
    font-size: 18px;        /* 🔥 bigger text */
    line-height: 1.7;
    color: #1f2937;
}



                        .swiper-button-prev,
                        .swiper-button-next {
                            color: white;
                        }

                        .swiper-pagination-bullet {
                            background: rgba(255,255,255,0.5);
                        }

                        .swiper-pagination-bullet-active {
                            background: white;
                        }

                       @media (max-width: 768px) {
    .patientCareSlider {
        padding: 0 12px;
    }

    .careCard {
        min-height: 220px;
        padding: 22px;
    }

    .careCard h3 {
        font-size: 25px;
    }

    .careCard p {
        font-size: 17px;
        line-height: 1.5;
    }

    .swiper-button-prev,
    .swiper-button-next {
        display: none; /* ❌ arrows hide on mobile */
    }
}

                    `}</style>

                </div>
            </div>
        </section>
    );
}

export default PatientCare;
